import { useState } from "react";

export default function EmailModal({ onSubmit }) {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!email.trim()) {
            setError("Email is required");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError("Enter a valid email address");
            return;
        }

        setLoading(true);
        await onSubmit(email);
        setLoading(false);
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4">

            <div className="
        bg-white w-full max-w-md 
        rounded-2xl shadow-2xl 
        p-8 
        animate-fadeIn
      ">

                {/* Title */}
                <h2 className="text-2xl font-semibold text-[#102D33] mb-2">
                    Welcome
                </h2>

                <p className="text-sm text-gray-600 mb-6">
                    Enter your email to continue using the Patent Knowledge Agent.
                </p>

                {/* Input */}
                <div className="relative mb-3">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setError("");
                        }}
                        placeholder="your@email.com"
                        className={`
              w-full border rounded-lg px-4 py-3 pr-10
              focus:outline-none focus:ring-2 focus:ring-[#102D33]
              transition
              ${error ? "border-red-500 focus:ring-red-400" : "border-gray-300"}
            `}
                    />

                    {/* Email Icon */}
                    {/* <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
                        ✉️
                    </div> */}
                </div>

                {/* Error */}
                {error && (
                    <div className="text-red-500 text-sm mb-4 bg-red-50 border border-red-200 rounded-md px-3 py-2">
                        {error}
                    </div>
                )}

                {/* Button */}
                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className={`
            w-full py-3 rounded-lg font-medium text-sm
            bg-gradient-to-r from-[#0f2f36] to-[#174a52]
            text-white transition-all duration-200
            flex items-center justify-center gap-2
            ${loading ? "opacity-70 cursor-not-allowed" : "hover:scale-[1.02]"}
          `}
                >
                    {loading ? (
                        <>
                            <Spinner />
                            Processing...
                        </>
                    ) : (
                        "Continue"
                    )}
                </button>

                {/* Footer */}
                <p className="text-xs text-gray-400 mt-4 text-center">
                    Your email will only be used for notifications about low-confidence queries to ai-admin.
                </p>
            </div>
        </div>
    );
}

/* Spinner Component */
function Spinner() {
    return (
        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
    );
}